// 日本語テーブル（機械翻訳・未校正 — ruling G4）。
// The Japanese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
import { boxDims, HW } from '../doc.js';
const S = {
  title: "仕切りトレイ",
  view: {
    "2d": "区画を編集",
    "3d": "3D表示",
  },
  gCell: "選択中の区画",
  gSize: "トレイサイズ",
  gWalls: "壁",
  gStack: "積み重ね",
  selName: (col, row, c) => `${col + 1} 列目 · ${row + 1} 番目 — ${c} mm`,
  colSize: "列の幅",
  cellSize: "区画の深さ",
  kinds: {
    auto: "自動",
    "1/2": "1/2",
    "1/3": "1/3",
    "2/3": "2/3",
    mm: "mm を設定",
  },
  split: "分割",
  addCol: "列を追加",
  del: "削除",
  w: "幅（mm）",
  d: "奥行（mm）",
  bed: "プリントベッド（mm）",
  bedOption: (w, d) => `${w} × ${d}`,
  bedWarn: (w, d) => `トレイが ${w} × ${d} mm のプリントベッドより大きい — 1回でプリントできない可能性があります`,
  wall: "壁の厚さ",
  fillet: "角の半径",
  divider: "仕切りの高さ",
  stackable: "積み重ね可能（上下の縁がロック）",
  clearance: "積み重ねクリアランス",
  stackNote: (h) => `3段積み: 高さ ${Math.round((3 * (h - 1) + 1) * 10) / 10} mm · さらに1段で ${Math.round((h - 1) * 10) / 10} mm 高くなります`,
  size: (w, d, h) => `${w} × ${d} × ${h} mm`,
  gBox: "収納ボックス",
  boxOn: "ボックスとフタを追加",
  trayCount: "トレイの数",
  partLabel: "ダウンロードしたパーツ",
  explode: "分解",
  parts: {
    tray: "トレイ",
    box: "ボックス",
    latch: "ラッチ",
    lid: "フタ",
  },
  boxNote: (wo, dd, hb, n) => `ボックス ${wo} × ${dd} × ${hb} mm · トレイ${n}個分`,
  hwNote: (hinges) => `${HW.screw} mm ナット × ${hinges} · ピン ${HW.pin} × ${HW.pinLen} mm × 1（または 1.75 mm フィラメント）`,
  bedWarnPart: (part, w, d) => `${part} のプリントサイズは ${w} × ${d} mm — プリントベッドより大きく、1回でプリントできない可能性があります`,
  tallWarn: (part, z) => `${part} の高さは ${z} mm — ほとんどのプリンターの高さを超えます`,
  problem: {
    "auto-squeezed": "自動区画のスペースがありません — 設定した区画サイズを小さくしてください",
    "too-small": "区画が小さすぎます（壁の厚さの最低2倍必要です）",
    overflow: "設定したサイズの合計がトレイを超えています",
    "fractions-over": "割合の合計が1を超えています",
    "corner-clipped": "角の区画が角の半径で切り取られます — 半径を小さくしてください",
    "too-shallow": "トレイが浅すぎます — 高さを上げるか壁の厚さを減らしてください",
    "stack-wall": "ロック縁には壁が薄すぎます — 壁を厚くするかクリアランスを減らしてください",
    "stack-shallow": "トレイが浅すぎて積み重ねられません — 高さを上げてください",
    "box-narrow": (doc) => `ボックスが狭くヒンジが入りません — トレイは最低 ${Math.round(boxDims(doc).minW * 10) / 10} mm 必要です（または角の半径を減らす）`,
  },
  dlstl: "STL",
  copied: "コピーしました",
  fatal: "計算機を読み込めません — ページを再読み込みしてください",
  unitMm: " mm",
  pct: (v) => `${v}%`,
  aboutP: "引き出し・デスク・工具箱を整理する仕切りトレイをデザイン。サイズも区画も自由に決められ、積み重ねられる縁にもできます。3MF/STL を無料ダウンロード。",
};
export default S;
